import 'css-chunk-1JavaScriptSource/components/_Dialogs/modal-dialog/style.module.scss';export default {
  "dialog": "_dialog_1wxcw_1",
  "MessageAlertFadeIn": "_MessageAlertFadeIn_1wxcw_1",
  "closeButton": "_closeButton_1wxcw_37",
  "active": "_active_1wxcw_47",
  "content": "_content_1wxcw_51"
};